export const Clients = ({ primaryFontColor = "#ffd800" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.003"
      height="24"
      viewBox="0 0 26.003 24"
    >
      <g id="hr" transform="translate(-3 -6)">
        <path
          id="Path_64581"
          data-name="Path 64581"
          d="M33.312,7.817H25.442l-1.46-2.189A1.41,1.41,0,0,0,22.809,5h-6.4A1.409,1.409,0,0,0,15,6.409V9.226h2.174A3.282,3.282,0,0,1,19.91,10.69l.9,1.353h6.865a3.291,3.291,0,0,1,3.287,3.287v7.043h2.348a1.409,1.409,0,0,0,1.409-1.409V9.226A1.409,1.409,0,0,0,33.312,7.817Z"
          transform="translate(-5.717 1)"
          fill={primaryFontColor}
        />
        <path
          id="Path_64582"
          data-name="Path 64582"
          d="M22.607,20.817H14.18l-1.563-2.189A1.541,1.541,0,0,0,11.361,18H4.508A1.461,1.461,0,0,0,3,19.409V33.965a1.461,1.461,0,0,0,1.508,1.409h18.1a1.461,1.461,0,0,0,1.508-1.409V22.226a1.461,1.461,0,0,0-1.508-1.409ZM9.033,23.165a1.883,1.883,0,1,1,0,3.756,1.883,1.883,0,1,1,0-3.756ZM5.514,31.617A3.369,3.369,0,0,1,9.033,28.33a3.369,3.369,0,0,1,3.519,3.287ZM21.6,29.269H14.563V27.391H21.6Zm0-3.756H14.563V23.635H21.6Z"
          transform="translate(0 -5.373)"
          fill={primaryFontColor}
        />
      </g>
    </svg>
  );
};
